import { CountryListUrlSortField } from "@saleor/countries/urls";
import { CountrySortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
    sort: CountryListUrlSortField
  ): CountrySortField {
    switch (sort) {
      case CountryListUrlSortField.isoNumberCode:
        return CountrySortField.ISO_NUMBER_CODE;
      case CountryListUrlSortField.isoThreeCode:
        return CountrySortField.ISO_THREE_CODE;
      case CountryListUrlSortField.isoTwoCode:
        return CountrySortField.ISO_TWO_CODE;
      case CountryListUrlSortField.name:
        return CountrySortField.NAME;
      case CountryListUrlSortField.displayOrder:
        return CountrySortField.DISPLAY_ORDER;
    }
  }
  
  export const getSortQueryVariables = createGetSortQueryVariables(
    getSortQueryField
  );
  